import React, { useRef } from "react";
import About from "./About";
import WhyWe from "./WhyWe";
import studentImg from "../img/student.jpg";
import "../css/Home.css";
import MessageSection from "./MessageSection";
import Notification from "./Notification";
import Gallery from "./Gallery";
import "react-bootstrap";
const Home = () => {
  const notificationRef = useRef(null);

  const scrollToNotifications = () => {
    if (notificationRef.current) {
      notificationRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div>
      {/* ================= HERO SECTION ================= */}
      <section
        className="hero-section text-light text-center d-flex align-items-center justify-content-center"
        style={{
          backgroundImage: `url(${studentImg})`,
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container hero-content py-5">
          <h1 className="display-4 fw-bold animate-title">
            Learn From The Best Educators
          </h1>
          <p className="lead mt-3 mb-4 animate-subtitle">
            Build your career with certified vocational training programs.
          </p>
          <div className="d-flex justify-content-center gap-3">
            {/* <button
              onClick={scrollToNotifications}
              className="btn btn-outline-light btn-lg animate-btn"
            >
              View Notifications
            </button> */}
            <a href="/coursesoffered" className="btn btn-primary btn-lg animate-btn">
              Explore Courses
            </a>
          </div>
        </div>
      </section>

      {/* ================= NOTIFICATION SECTION (SCROLLABLE) ================= */}
      <div className="notification-wrapper" ref={notificationRef}>
        <div className="scrollable-notification-box">
          <Notification />
        </div>
      </div>

      {/* ================= OTHER SECTIONS ================= */}
      <WhyWe />
      <MessageSection />
      <Gallery />
    </div>
  );
};

export default Home;
